export default "__VITE_ASSET__3d6608b0__"